// Show issue modal

$(function () {
  if (isFeatureEnabled('issues')) {
    app.showIssueModal = new jBox('Modal', {
      addClass: 'modal-bim360 modal-bim360--title-left',
      width: 520,
      height: '100%',
      title: 'Issue',
      content: '<div class="show-issue-modal__wrapper"></div>',
      closeButton: 'title',
      isolateScroll: false,
      adjustDistance: 16,
      createOnInit: true,
      zIndex: 10000,
      onCreated: function () {
        updateModalCloseIcon(this.wrapper);
        this.wrapper.find('.jBox-title').append(
          $('<div class="show-issue-modal__edit-button icon-edit">').on('click', function () {
            editIssue(app.showIssueModal.issueId);
          })
        );
        initEditAttachmentsTooltip();
      },
      onOpen: function () {
        // TODO add attachments loading etc. also to tooltip
        updateIssueAttachmentAmount(0);
        loadComments(app.showIssueModal.issueId);
      }
    });
  }
});

// Open the show issue modal

function openIssueModal(issueId) {
  issueId && setIssueModalContent(issueId);
  app.showIssueModal.issueId = issueId;
  app.showIssueModal.open();
}

// Edit an issue

function editIssue(issueId) {
  var issue = app.issues[issueId];
  app.editIssue = issueId;
  app.showIssueModal.close();
  openCreateIssueModal(issue);
}

// Get a username from hard coded names

function getUsername(user_id) {
  if (settings && settings.usersnames && settings.usersnames[user_id]) {
    return settings.usersnames[user_id];
  }
  return user_id;
}

function showUsername(str, user_id) {
  return isFeatureEnabled('showUsernames') ? str.replace('{0}', getUsername(user_id)) : '';
}

// Set the content of the issue modal

function setIssueModalContent(issueId) {
  var issue = app.issues[issueId];

  // Reset wrapper
  var wrapper = $('.show-issue-modal__wrapper');
  wrapper.html('');

  // Created
  wrapper.append(
    $('<div class="show-issue-modal__created"/>').html(
      __('dateCreatedOn') + ' ' +
      getIssueCreatedDate(issue.createdAt, true) +
      showUsername(' ' + __('createdBy') + ' {0}', issue.createdBy)
    )
  );

  // Title
  wrapper.append($('<h3 class="show-issue-modal__title"/>').html(issue.title));

  // Description
  var description = $('<div class="show-issue-modal__description"/>').html(
    issue.description || __('issueNoticeNoDescription')
  );
  wrapper.append(description);
  if (!issue.description) {
    description.addClass('show-issue-modal__description--empty');
  }

  // Files
  if (isFeatureEnabled('issueAttachments')) {
    wrapper.append($('<h4 class="show-issue-modal__subtitle"/>').html(__('attachmentsTitle')));

    var filesContainer = $('<div class="show-issue-modal__attachments"/>');
    wrapper.append(filesContainer);

    // Edit files contrainer
    var editFilesContainer = $('.edit-issue__attachments-tooltip-content');

    // Files
    $.ajax({
      url: settings.apiEndpoint + '/api/files',
      type: 'GET',
      headers: {
        apiToken: settings.apiToken,
        issueId: issueId
      },
      beforeSend: function () {
        $('.show-issue-modal__attachments')
          .addClass('show-issue-modal__attachments--empty')
          .html(__('attachmentsNoticeLoadingAttachments'));
        updateIssueAttachmentAmount(0);
        editFilesContainer.html(
          '<div class="show-issue-modal__attachments-content--empty">' + __('attachmentsNoticeLoadingAttachments') + '</div>'
        );
      },
      success: function (response) {
        $('.show-issue-modal__attachments').removeClass('show-issue-modal__attachments--empty');
        if (!response.success) {
          editFilesContainer.html(
            '<div class="show-issue-modal__attachments-content--empty">' + __('attachmentsNoticeAttachmentsCouldNotBeLoaded') + '</div>'
          );
          $('.show-issue-modal__attachments')
            .addClass('show-issue-modal__attachments--empty')
            .html(__('attachmentsNoticeAttachmentsCouldNotBeLoaded'));
          return;
        } else if (!response.files || !response.files.length) {
          editFilesContainer.html('<div class="show-issue-modal__attachments-content--empty">' + __('attachmentsNoticeNoAttachments') + '</div>');
          $('.show-issue-modal__attachments')
            .addClass('show-issue-modal__attachments--empty')
            .html(__('attachmentsNoticeNoAttachments'));
          return;
        } else {
          updateIssueAttachmentAmount(response.files.length);
          editFilesContainer.html('');
          $('.show-issue-modal__attachments').html('');
          for (var i = 0; i < response.files.length; i++) {
            var file = response.files[i];
            var isImage = ['png', 'jpg', 'jpeg'].indexOf(file.filename.split('.').pop()) > -1;

            // Add attachments to issue
            filesContainer.append(
              $('<div class="show-issue-modal__attachment"/>').html(
                '<a href="' +
                settings.apiEndpoint +
                '/file/' +
                file.issue_id +
                '/' +
                file.filename +
                '" target="_blank" data-title="' +
                file.filename_original.replace('"', "'") +
                '" class="' + (isImage ? 'attachment-image' : '') + '"><div class="show-issue-modal__attachment-file' +
                (isImage ? ' show-issue-modal__attachment-file--image' : ' icon-file') +
                '" ' +
                (isImage
                  ? ' style="background-image: url(' +
                  settings.apiEndpoint +
                  '/file/' +
                  file.issue_id +
                  '/' +
                  file.filename +
                  ')"'
                  : '') +
                '></div><div class="show-issue-modal__attachment-name">' +
                file.filename_original +
                '</div></a>'
              )
            );

            // Add attachments to edit tooltip
            editFilesContainer.append(
              $('<div class="edit-attachment__container" data-id="' + file.id + '"/>').html(
                '<div class="edit-attachment__file' +
                (isImage ? ' edit-attachment__file--image' : ' icon-file') +
                '" ' +
                (isImage
                  ? ' style="background-image: url(' +
                  settings.apiEndpoint +
                  '/file/' +
                  file.issue_id +
                  '/' +
                  file.filename +
                  ')"'
                  : '') +
                '></div><div class="edit-attachment__filename">' +
                file.filename_original +
                '</div><div class="edit-attachment__button button button--small" onclick="deleteAttachment(' +
                file.id +
                ')">' + __('deleteButton') + '</div>'
              )
            );
          }
          if (app.imageModal) {
            app.imageModal.detach().attach();
          }
        }
      },
      error: function (response) {
        $('.show-issue-modal__attachments')
          .addClass('show-issue-modal__attachments--empty')
          .html(__('attachmentsNoticeAttachmentsCouldNotBeLoaded'));
      }
    });
  }

  // Comments title
  wrapper.append($('<div class="show-issue-modal__comments-title"/>').html(__('commentsSectionTitle')));

  // Add comments
  var addCommentsWrapper = $('<div class="show-issue-modal__comments-add"/>');
  wrapper.append(addCommentsWrapper);

  addCommentsWrapper.append(
    $('<input class="textfield textfield--button-height" rows="1" data-autoresize placeholder="' + __('commentsSectionWriteAComment') + '"/>')
  );

  addCommentsWrapper.append(
    $('<button class="button button--has-icon" onclick="saveComment()"/>').html(
      '<span class="button__icon icon-edit"></span>'
    )
  );

  // Comments
  wrapper.append($('<div class="show-issue-modal__comments"/>'));
}

// Create issue modal

function initCreateIssueModal() {
  if (!app.createIssueModal) {
    app.createIssueModal = new jBox('Modal', {
      addClass: 'modal-bim360',
      width: 520,
      title: 'Create Issue',
      content: $('#modal-create-issue-content'),
      closeButton: 'title',
      isolateScroll: false,
      adjustDistance: 16,
      createOnInit: true,
      onCreated: function () {
        updateModalCloseIcon(this.wrapper);
      },
      onClose: function () {
        clearFilesToAttach('edit-issue');
        app.editAttachmentsTooltip && app.editAttachmentsTooltip.close();
      }
    });
  }
}

// Get issues

function loadIssues() {

  if (!isFeatureEnabled('issues')) {
    return;
  }

  if (app.issuesLoading || app.public) {
    return;
  }

  $('.issues__issues').html('<div class="panel__empty">' + __('panelNoticeLoadingIssues') + '</div>');

  app.issuesLoading = true;

  getForgeToken(function (access_token) {
    // We already have an issue container ID
    if (app.issueContainerId) {
      getIssues(app.issueContainerId, access_token);
      return;
    }

    // Get ids from cached node
    // if (app.node && app.node.parents) {
    //   var ids = getIDsFromParents(app.node.parents);
    // } else {
    //   // TODO Fallback won't work with ?urn in URL
    //   var ids = {
    //     hubId: settings.initialHubId,
    //     projectId: settings.initialProjectId
    //   };
    // }

    // Get ids from storage or from settings
    var ids = getProjectIds();

    // Abort is no ids found
    if (!ids || !ids.hubId || !ids.projectId) {
      error();
      return;
    }

    // Get projects
    $.ajax({
      url: 'https://developer.api.autodesk.com/project/v1/hubs/' + ids.hubId + '/projects',
      headers: {
        Authorization: 'Bearer ' + access_token
      },
      success: function (response) {
        // Find correct project
        $.each(response.data, function (index, item) {
          if (ids.projectId == item.id) {
            app.issueContainerId = item.relationships.issues.data.id;

            // Find issue types
            $.ajax({
              url: settings.apiEndpoint + '/api/issue-types',
              method: 'GET',
              data: {
                container_id: app.issueContainerId,
                access_token: access_token
              },
              // url:
              //   'https://developer.api.autodesk.com/issues/v1/containers/' +
              //   app.issueContainerId +
              //   '/ng-issue-types?include=subtypes',
              // headers: {
              //   'Authorization': 'Bearer ' + access_token,
              //   'Content-Type': 'application/vnd.api+json'
              // },
              success: function (response) {
                // Set issue types
                updateIssueTypes(response);

                // Get issues and stop loop
                getIssues(app.issueContainerId, access_token);

                // Get users
                // Make sure to test getting users with failed requests
                // If you don't have the right for "account:read" this request will fail with status code 403

                // $.ajax({
                //   url:
                //     // Make sure to test getting users with failed requests
                //     // If you don't have the right for "account:read" this request will fail with status code 403

                //     'https://developer.api.autodesk.com/hq/v1/accounts/' +
                //     ids.hubId.replace('b.', '') +
                //     '/users',
                //   headers: {
                //     Authorization: 'Bearer ' + access_token
                //   },
                //   success: function (response_users) {
                //     console.log('Users', response_users);
                //   },
                //   complete: function () {
                //     // Set issue types
                //     updateIssueTypes(response);

                //     // Get issues and stop loop
                //     getIssues(app.issueContainerId, access_token);
                //   },
                //   error: function () {
                //     // Set issue types
                //     updateIssueTypes(response);

                //     // Get issues and stop loop
                //     getIssues(app.issueContainerId, access_token);
                //   }
                // });
              },
              error: function () {
                error();
              }
            });
          }
        });
      },
      error: function () {
        error();
      }
    });
  });
}

// Load issues with issue container id

function getIssues(issueContainerId, access_token) {

  $.ajax({
    url: settings.apiEndpoint + '/api/issues',
    method: 'GET',
    data: {
      container_id: app.issueContainerId,
      access_token: access_token
    },
    // url:
    //   'https://developer.api.autodesk.com/issues/v1/containers/' +
    //   issueContainerId +
    //   '/quality-issues?page[limit]=100&sort=-created_at&include=attachments',
    // headers: {
    //   'Authorization': 'Bearer ' + access_token,
    //   'Content-Type': 'application/vnd.api+json'
    // },
    complete: function () {
      app.issuesLoading = false;
    },
    success: function (response) {
      // Reset container
      $('.issues__issues').html('');

      // Store issue references
      app.issues = {};

      // Set issues
      $.each(response.results.slice().reverse(), function (index, issue) {
        app.issues[issue.id] = issue;
        addIssue(issue);
      });
    },
    error: function () {
      $('.issues__issues').html('');
      error();
    }
  });
}

// Create an issues container

function addIssue(issue) {
  // Wrapper
  var wrapper = $('.issues__issues');

  // Container
  var container = $('<div class="issues__container"/>').data('issue-data', issue).appendTo(wrapper);

  container.on('click', function () {
    openIssueModal(issue.id);
  });

  // Date created
  var issueCreatedDate = getIssueCreatedDate(issue.createdAt, true);
  var issueCreatedContent = issueCreatedDate;
  $('<div class="issues__created"/>').html(issueCreatedContent).appendTo(container);

  // Pushpin
  if (issue && issue.attributes && issue.attributes.pushpin_attributes) {
    $('<div class="issues__has-pushpin icon-location-on"/>').appendTo(container);
  }

  // Title
  var title = $('<div class="issues__title"/>').appendTo(container);
  title.html(issue.title);
}

// Update jBox close icon

function updateModalCloseIcon(el) {
  el.find('.jBox-closeButton').addClass('icon-clear').html('');

  // el.find('.jBox-closeButton').on('click', function () {
  //   console.log('DEBUGGING', this);
  // }.bind(this));
}

// Toggle issues modal

function openCreateIssueModal(issue) {
  initCreateIssueModal();
  resetIssueTypeSelect(false, issue);

  if (!issue) {
    app.editIssue = null;
  }

  // console.log('issue', issue);

  $('.create-issue__modal-pushpin-icon')
    .removeClass('icon-location-on')
    .removeClass('icon-location-check')
    .addClass(issue && issue.attributes && issue.attributes.pushpin_attributes ? 'icon-location-check' : 'icon-location-on');

  $('.create-issue__modal-pushpin-text').html(
    issue && issue.attributes && issue.attributes.pushpin_attributes ? __('pushPinNoticeChangePushPinLocation') : __('pushPinNoticeAddPushPin')
  );

  $('#create-issue__modal-pushpin-button')[issue && issue.attributes && issue.attributes.pushpin_attributes ? 'addClass' : 'removeClass'](
    'push-pin-added'
  );

  $('.edit-issue__attachments')[issue ? 'addClass' : 'removeClass']('attachments-active');

  // $('.create-issue__modal-attach-icon')
  //   .removeClass('icon-file-check')
  //   .removeClass('icon-file-plus')
  //   .addClass(false ? 'icon-file-check' : 'icon-file-plus');

  // $('.create-issue__modal-attach-text').html(
  //   false ? 'Change selected attachments' : 'Attach images or documents'
  // );

  // $('#create-issue__modal-attach-button')[false ? 'addClass' : 'removeClass'](
  //   'attachment-added'
  // );

  $('#create-issue__modal-pushpin-button').data(
    'pushpin-data',
    issue && issue.attributes && issue.attributes.pushpin_attributes
      ? {
        attributes: {
          // target_urn: issue.attributes.target_urn,
          starting_version: issue.attributes.starting_version,
          sheet_metadata: issue.attributes.sheet_metadata,
          pushpin_attributes: issue.attributes.pushpin_attributes
        }
      }
      : null
  );

  app.createIssueModal.setTitle(issue ? __('issueEditIssue') : __('issueCreateIssue'));
  $('#create-issue__modal-title').val(issue ? issue.title : '');
  $('#create-issue__modal-description').val(issue ? issue.description : '');
  app.createIssueModal.open();
}

function closeCreateIssueModal() {
  initCreateIssueModal();
  app.createIssueModal.close();
}

// Save issue

function saveIssue() {
  if (app.issueIsSaving) {
    return false;
  }

  // Abort if we don't have an issue container id
  if (!app.issueContainerId) {
    error();
    return;
  }

  // Data
  var title = $('#create-issue__modal-title').val();
  var description = $('#create-issue__modal-description').val();

  // Construct data
  var data = {
    title: title,
    description: description,
    // REMOVED AS IT WILL CAUSE ERROR // issueTypeId: getIssueTypeId(),
    issueSubtypeId: getIssueSubTypeId(),
  };

  // TODO
  var ppData = $('#create-issue__modal-pushpin-button').data('pushpin-data');

  if (ppData) {
    // data.linkedDocuments = ppData.linkedDocuments;
  }

  // Editing issue
  if (app.editIssue) {
    var method = 'PATCH';
    var url = settings.apiEndpoint + '/api/issue/' + app.editIssue;
  } else {
    // Creating issue
    var method = 'POST';
    var url = settings.apiEndpoint + '/api/issue';

    // Removed in v2 // data.createdAt = new Date().toISOString();
    data.status = 'open';
  }

  // Save issue
  $.ajax({
    url: '/api/forge/oauth/token',
    beforeSend: function () {
      app.issueIsSaving = true;
      $('#create-issue__modal-save-button').attr('disabled', 'disabled').addClass('loading-bar');
    },
    success: function (response) {
      var access_token = response.access_token;

      $.ajax({
        url: url,
        method: method,
        data: JSON.stringify({
          container_id: app.issueContainerId,
          access_token: access_token,
          data: data
        }),
        contentType: 'application/json',
        success: function (response) {
          function handleSuccess() {
            app.issueIsSaving = false;
            const button = $('#create-issue__modal-save-button');
            resetButtonLoadingStatus(button, 'Save');
            button.removeAttr('disabled').removeClass('loading-bar');
            success(app.editIssue ? __('issueSaveSuccessNoticeEdited') : __('issueSaveSuccessNoticeCreated'));
            app.editIssue = null;
            loadIssues();
            closeCreateIssueModal();
          }

          function handleError() {
            app.issueIsSaving = false;
            const button = $('#create-issue__modal-save-button');
            resetButtonLoadingStatus(button, 'Save');
            button.removeAttr('disabled').removeClass('loading-bar');
            error();
          }

          if (!response || !response.id) {
            handleError();
          }

          if (getFilesToAttachAmount('edit-issue') > 0) {
            uploadFiles(response.id, handleSuccess, handleError);
          } else {
            handleSuccess();
          }
        },
        error: function () {
          app.issueIsSaving = false;
          $('#create-issue__modal-save-button').removeAttr('disabled').removeClass('loading-bar');
          error();
        }
      });
    },
    error: function () {
      app.issueIsSaving = false;
      $('#create-issue__modal-save-button').removeAttr('disabled').removeClass('loading-bar');
      error();
    }
  });
}

// Update issue types

function updateIssueTypes(data) {
  resetIssueTypeSelect(true);

  // Store types
  app.issueTypes = {};

  $.each(data.results, function (index, category) {
    if (category.isActive) {
      $('.issue-category-select__options').append(
        $('<div class="issue-category-select__option-title"/>').html(category.title)
      );
      app.issueTypes[category.id] = category.title;

      $.each(category.subtypes, function (index, subtype) {
        if (subtype.isActive) {
          $('.issue-category-select__options').append(
            $('<div class="issue-category-select__option-button"/>')
              .attr('data-id', subtype.id)
              .data('issueTypeId', subtype.issueTypeId)
              .data('issueSubTypeId', subtype.id)
              .html(subtype.title)
              .on('click', function () {
                selectIssueType(category.title, subtype.title, subtype.issueTypeId, subtype.id);
              })
          );
          app.issueTypes[subtype.id] = subtype.title;
        }
      });
    }
  });
}

// Toggle the issue type options

function toggleIssueTypeSelectOptions() {
  $('.issue-category-select__wrapper').toggleClass('options-expanded');
}

// Reset the type id select

function resetIssueTypeSelect(empty, issue) {
  if (empty) {
    $('.issue-category-select__selection, .issue-category-select__options').html('');
  }

  $('.issue-category-select__selection').data('issueTypeId', '');
  $('.issue-category-select__selection').data('issueSubTypeId', '');
  $('.issue-category-select__wrapper.type-selected').removeClass('type-selected');
  $('.issue-category-select__wrapper.options-expanded').removeClass('options-expanded');
  $('.issue-category-select__option-button.option-selected').removeClass('option-selected');

  if (issue) {
    selectIssueType(
      app.issueTypes[issue.issueTypeId],
      app.issueTypes[issue.issueSubtypeId],
      issue.issueTypeId,
      issue.issueSubtypeId
    );
  }
}

// Select an issue type id with sub type id

function selectIssueType(issueTypeTitle, issueSubTypeTitle, issueTypeId, issueSubTypeId) {
  resetIssueTypeSelect();
  $('.issue-category-select__selection').data('issueTypeId', issueTypeId);
  $('.issue-category-select__selection').data('subTypeId', issueSubTypeId);
  $('.issue-category-select__wrapper').addClass('type-selected');
  $('.issue-category-select__selection[data-id="' + issueSubTypeId + '"]').addClass('option-selected');
  $('.issue-category-select__selection').html(
    '<span>' + issueTypeTitle + '</span>: <span>' + issueSubTypeTitle + '</span>'
  );
}

// Get the issue type id and sub type id

function getIssueTypeId() {
  return $('.issue-category-select__selection').data('issueTypeId');
}

function getIssueSubTypeId() {
  return $('.issue-category-select__selection').data('subTypeId');
}

// Get the issue created at date

function getIssueCreatedDate(createdDate, addTime) {
  createdDate = new Date(createdDate);

  var months = getMonthNames(settings.language);

  var date = '';
  date += createdDate.getDate() + '. ';
  date += months[createdDate.getMonth()] + ' ';
  date += createdDate.getFullYear();

  if (addTime) {
    date += ' ' + __('timeAt') + ' ';
    date += ('0' + createdDate.getHours()).substr(-2) + ':';
    date += ('0' + createdDate.getMinutes()).substr(-2);
  }

  return date;
}

// Download issue list with pushpin information

function downloadIssueList() {
  var content = 'Title,Description,Created,Issue ID,Object ID,Object GUID';

  if (settings.guidProperty) {
    content += ',Object ' + settings.guidProperty;
  }

  content += ',PushPin X,PushPin Y,PushPin Z,Sheet GUID,Sheet name' + '\n';

  $.each($('.issues__container'), function (index, item) {
    var data = $(item).data('issue-data');

    if (data.attributes.pushpin_attributes && data.attributes.pushpin_attributes.attributes_version) {
      // Title
      content += (data.attributes.title || '') + ',';

      // Description
      content += (data.attributes.description || '') + ',';

      // Created
      content += (data.attributes.createdAt || '') + ',';

      // Issue id
      content += (data.id || '') + ',';

      // Object id
      content += (data.attributes.pushpin_attributes.object_id || '') + ',';

      // GUID
      content +=
        (app.dbIds[data.attributes.pushpin_attributes.object_id] &&
          app.dbIds[data.attributes.pushpin_attributes.object_id]['GUID']
          ? app.dbIds[data.attributes.pushpin_attributes.object_id]['GUID']
          : '') + ',';

      // Custom GUID
      if (settings.guidProperty) {
        content +=
          (app.dbIds[data.attributes.pushpin_attributes.object_id] &&
            app.dbIds[data.attributes.pushpin_attributes.object_id][settings.guidProperty]
            ? app.dbIds[data.attributes.pushpin_attributes.object_id][settings.guidProperty]
            : '') + ',';
      }

      // Pushpin data
      content += (data.attributes.pushpin_attributes.location.x || '') + ',';
      content += (data.attributes.pushpin_attributes.location.y || '') + ',';
      content += (data.attributes.pushpin_attributes.location.z || '') + ',';

      // Sheet data
      content += (data.attributes.sheet_metadata.sheetGuid || '') + ',';
      content += data.attributes.sheet_metadata.sheetName || '';

      // New line
      content += '\n';
    }
  });

  // Download as CSV
  downloadFile('issues.csv', content);
}

function downloadFile(filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
  element.setAttribute('download', filename);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}
